import { getWidgetBaseUrl } from "./origin";

export async function trpcCall<T = unknown>(
  procedure: string,
  input: unknown,
  opts: { method: "query" | "mutation" }
): Promise<T> {
  const url = `${getWidgetBaseUrl()}/api/trpc/${procedure}`;
  const init: RequestInit = {
    credentials: "include", // send .submagic.co cookies
    headers: { "content-type": "application/json" },
  };

  let finalUrl = url;
  if (opts.method === "query") {
    const encoded = encodeURIComponent(JSON.stringify({ json: input }));
    finalUrl = `${url}?input=${encoded}`;
    init.method = "GET";
  } else {
    init.method = "POST";
    init.body = JSON.stringify({ json: input });
  }

  const res = await fetch(finalUrl, init);
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`tRPC ${procedure} failed: ${res.status} ${text}`);
  }
  const json = (await res.json()) as any;
  if (json.error) throw new Error(json.error.message);
  return json.result.data.json as T;
}
